import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import Breadcrumb from '../components/Breadcrumb'
import ItAssetReportLayer from '../components/ItAssetReportLayer'

const ItAssetReportPage = () => {
  return (
    <MasterLayout>
        <Breadcrumb title='IT Asset Report' />
        <ItAssetReportLayer />
    </MasterLayout>
  )
}

export default ItAssetReportPage

